import StadiumRemote from '../remote/stadiumRemote'
import { createOrderParams } from '../utils/orderUtils'

/**
 * Syncs the order to stadium
 *
 * @returns {Boolean} successful or failed
 */
export const createOrder = async (curOrder) => {
  try {
    const result = await StadiumRemote.createPosOrder({
      ...createOrderParams(curOrder),
      webOrder: true,
    })

    if (result?.status !== 201) {
      throw new Error('Failed to create order')
    }

    return true
  } catch (error) {
    return false
  }
}
